import React , { useState, useEffect } from "react";
import {Stack, Box, Input, styled, Button } from "@mui/material";
import {Badge, theme} from "@material-ui/core";
import Select from "react-select";

const TXTRoundedDiv= styled("div")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    border: "#65BDC0",
    width: "100%",
    height: "100%",
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "10px",

}));

const StyledBox= styled(Box)({
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "5px",
});

const StyledInput= styled(Input)({
  fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"

});

const StyledSelect= styled(Select)({
    fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"
});

export default function CompanyRegister(props){
    const [errors, setErrors]= useState({});
    
    const [formData, setFormData]=useState({
        company_no: '',
        name: '',
        email: '',
        telephone1: '',
        telephone2: '',
        tin_no: ''
    });
    
    const handleChangeInput=(e)=>{
         const { name, value }= e.value;
         setFormData({
            ...formData,
            [name]: value
         
         });
         setErrors({})
    }
    
    const validateForm=(data)=>{
        let errors={}
        
        if(!(data.company_no.trim())){
          errors.company_no='Please enter Company Number'
        }

        if(!(data.name.trim())){
            errors.name='Please enter Company Name'
          }

        if(!(data.email.trim())){
            errors.email='Please enter Company Email'
          }
        if(!(data.telephone1.trim())){
            errors.telephone1='Please enter Primary Mobile No'
          }
        if(!(data.telephone2.trim())){
            errors.telephone2='Please enter Secondary Mobile No'
          }
        if(!(data.tin_no.trim())){
            errors.tin_no='Please enter TIN No'
          }
          

        return errors;
    }

    const handleButtonClick=()=>{
      const newErrors=validateForm(formData);
      if(Object.keys(newErrors).length===0){
        console.log("success")

        let APIURL="/myapi/CompanyPostView";
        let headerOptions={
            method: 'POST',
            headers:{
                'Content-type': 'application/json'
            },
            body: JSON.stringify(formData)
        }

        fetch(APIURL, headerOptions)
        .then( response => response.json())
        .then( json => console.log("errors=" + json ))
        .finally(()=>{
        
        })
        .catch( errors=>console.log("errors=" + errors ))

      }
      else{
        console.log("success")
      }
    }

    return(
    <Stack direction="row" spacing={1}>
       <StyledBox flex={4}>
         
         <TXTRoundedDiv>
           <StyledInput
            name="company_no"
            placeholder="Company Number"
            onChange={handleChangeInput}

           />
           { errors.company_no && (<span> errors.company_no </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
           <StyledInput
            name="name"
            placeholder="Company Name"
            onChange={handleChangeInput}

           />
           { errors.name && (<span> errors.name </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
           <StyledInput
            name="email"
            placeholder="Company Email"
            onChange={handleChangeInput}

           />
           { errors.email && (<span> errors.email </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
           <StyledInput
            name="telephone1"
            placeholder="Primary Mobile Number"
            onChange={handleChangeInput}

           />
           { errors.telephone1 && (<span> errors.telephone1 </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
           <StyledInput
            name="telephone2"
            placeholder="Secondary Mobile No"
            onChange={handleChangeInput}

           />
           { errors.telephone2 && (<span> errors.telephone2 </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
           <StyledInput
            name="tin_no"
            placeholder="TIN No"
            onChange={handleChangeInput}

           />
           { errors.tin_no && (<span> errors.tin_no </span>)}
         </TXTRoundedDiv>
         
         <Button onClick={handleButtonClick} color="secondary" variant="contained">
            SAVE
         </Button>
       </StyledBox>

       <StyledBox flex={4}>

       </StyledBox>

       <StyledBox flex={4}>

       </StyledBox>
    </Stack>
   )
}